// @file Show feedback nudge if user came from Import page.
// Only show once per wall.
import { trackEventOnlyOnce } from '@@/bits/command_bar'
import { requestIdleCallback } from '@@/bits/request_idle_callback'
import { tryCatch } from '@@/bits/try_catch'

const showFeedbackNudgeAfterCompletedWallImport = async (): Promise<void> => {
  const { useSurfaceStore } = await import('@@/pinia/surface')
  const surfaceStore = useSurfaceStore()

  // Only show after 1 second when idle
  await new Promise<void>((r) => requestIdleCallback(r))
  await new Promise((r) => setTimeout(r, 1000))

  const [referrerUrl, error] = tryCatch(() => new URL(document.referrer))
  if (error) {
    // Invalid referrer URL, just ignore it
    return
  }

  if (referrerUrl.hostname === window.location.hostname && referrerUrl.pathname.endsWith('/import')) {
    trackEventOnlyOnce('wallImportCompletedFeedbackNudge', { localStorageKeySuffix: surfaceStore.wallId })
  }
}

export { showFeedbackNudgeAfterCompletedWallImport }
